import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import SvgIcon from '@mui/material/SvgIcon';
import WarningIcon from '@mui/icons-material/WarningRounded';
import { ReactComponent as ReportIcon } from 'assets/images/criticalIncident/exclamation_diamond.svg';
import { CIPriorityLevel } from 'components/CriticalIncident/interfaces';
import './PriorityCell.scss';

interface PriorityCellProps {
    priority: CIPriorityLevel;
}

const PRIORITY_COLORS = {
    critical: 'var(--color_red_background)',
    high: 'var(--color_orange_background)',
    normal: 'var(--color_neutral_30)'
} as const;

export const PriorityCell: React.FC<PriorityCellProps> = ({ priority }) => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    const priorityChipProps = useMemo(() => {
        return {
            [CIPriorityLevel.critical]: {
                label: t('critical'),
                style: { backgroundColor: PRIORITY_COLORS.critical },
                icon: <SvgIcon component={ReportIcon} color="error" style={{ padding: '4px' }} inheritViewBox />
            },
            [CIPriorityLevel.high]: {
                label: t('high'),
                style: { backgroundColor: PRIORITY_COLORS.high },
                icon: <WarningIcon color="warning" className="priority-warning-icon" />
            },
            [CIPriorityLevel.normal]: {
                label: t('normal'),
                style: { backgroundColor: PRIORITY_COLORS.normal }
            }
        }[priority];
    }, [priority, t]);

    return <Chip key="priority" {...priorityChipProps} />;
};
